import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">91在线观看</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              91在线观看提供海量高清视频资源，支持免费在线播放，无需下载，流畅观看体验。随时随地畅享优质娱乐资源。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="/category">视频分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电影</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电视剧</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">综艺</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">动漫</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">纪录片</Link></li>
              <li><Link to="/category" className="text-sm text-background-400 hover:text-primary-400 transition-colors">体育</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/article" className="text-sm text-background-400 hover:text-primary-400 transition-colors">最新资讯</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">帮助中心</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>service@91zaixianguankan.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-9191</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                <span>北京市朝阳区光华路9号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 <strong>91在线观看</strong> 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">用户协议</a>
            <span className="text-background-700">|</span>
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <span className="text-background-700">|</span>
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}